/**
 * Declare global vars
 */
const attributeBase = 'data-mega-menu';

export class MegaMenu {

  constructor(element) {
    this.element = element;
    this.mobileMenu = element.querySelector(`[data-rs-navigation]`);
    this.mobileIndepthLink = this.mobileMenu.querySelectorAll(`[data-slide-aside-button]`);
    this.mobileBackLink = this.mobileMenu.querySelectorAll(`[data-slide-back-button]`);
    this.mobileMenuContainer = this.mobileMenu.querySelector(`[data-navigation-mega-container]`);
    this.mobileClose = this.mobileMenu.querySelectorAll(`[data-navigation-mega-close]`);
    this.mobileMenuItem = this.mobileMenu.querySelectorAll(`.${this.classes.indepthListItem}`);
    this.navClose = this.element.querySelector(`[data-rs-navigation-menu-icon]`);
    this.menuItems = this.element.querySelectorAll(`[data-navigation-mega-item]`);
    this.submenus = this.element.querySelectorAll(`[data-navigation-mega-submenu]`);
    this.overlay = document.querySelector('[data-navigation-mega-overlay]');
    this.megaMenuCloseBtns = this.element.querySelectorAll('[data-navigation-mega-close]');
    this.indepthItems = this.element.querySelectorAll('[data-navigation-mega-indepth-item]');
    this.indepthContents = this.element.querySelectorAll('[data-navigation-mega-indepth-content]');
    this.mobileSecondLevel = this.mobileMenu.querySelectorAll('.navigation-mega__indepth-content');
    this.mobileFirstLevelMenuItems = this.mobileMenu.querySelectorAll('.navigation-mega__indepth-link');

    this.openSubmenu = this.openSubmenu.bind(this);
    this.closeSubMenus = this.closeSubMenus.bind(this);
    this.openInDepthMenu = this.openInDepthMenu.bind(this);
    this.triggerDataLayerEvent = this.triggerDataLayerEvent.bind(this);
    this.addEventHandlers();
  }

  /**
   * Data Layer function
   */

  triggerDataLayerEvent(text, level) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'eventTracker',
      'eventCategory': '[JE] Navigation',
      'eventAction': text,
      'eventLabel': level
    });
  }

  /**
   * Add event handlers
   */
  addEventHandlers() {
    this.indepthContents.forEach(element => {
      const thirdLevelLinks = element.querySelectorAll('a');

      thirdLevelLinks.forEach(item => {
        item.addEventListener('click', clickEvent => {
          const secondLevelLink = item.closest('[data-navigation-mega-indepth-item]');
          const secondLevelLinkText = secondLevelLink.querySelector('a').text;
          const firstLevelLink = secondLevelLink.closest('[data-navigation-mega-item]').querySelector('.navigation-mega__menu-link');
          const firstLevelLinkText = firstLevelLink.querySelector('a').text;
          const textForDatalayerEvent = `${firstLevelLinkText.trim()}|${secondLevelLinkText.trim()}|${item.text.trim()}`;

          this.triggerDataLayerEvent(textForDatalayerEvent, 3);
        });
      });
    });


    this.indepthItems.forEach(element => {
      const secondLevelLink = element.querySelector('a');

      secondLevelLink.addEventListener('click', clickEvent => {
        const firstLevelLink = secondLevelLink.closest('[data-navigation-mega-item]').querySelector('.navigation-mega__menu-link');
        const firstLevelLinkText = firstLevelLink.querySelector('a').text;
        const textForDatalayerEvent = `${firstLevelLinkText.trim()}|${secondLevelLink.text.trim()}`;

        this.triggerDataLayerEvent(textForDatalayerEvent, 2);
      });
    });

    if (this.mobileSecondLevel.length) {
      this.mobileSecondLevel.forEach( item => {
        const secondLevel = item.querySelectorAll('.navigation-mega__indepth-list-item');

        if (secondLevel && secondLevel.length) {
          secondLevel.forEach( secondLevelItem => {
            const secondLevelLink = secondLevelItem.querySelector('.collapsible__trigger').querySelector('a');
            const thirdLevelLink = secondLevelItem.querySelector('.collapsible__content').querySelectorAll('a');

            if (!!secondLevelLink) {
              secondLevelLink.addEventListener('click', clickEvent => {
                const firstLevelLink = secondLevelLink.closest('.navigation-mega__indepth-content').querySelector('.navigation-mega__subtitle').querySelector('span').innerText.trim();
                const textForDatalayerEvent = `${firstLevelLink}|${secondLevelLink.text.trim()}`;

                this.triggerDataLayerEvent(textForDatalayerEvent, 2);
              });
            }

            if (!!thirdLevelLink) {
              thirdLevelLink.forEach(link => {
                link.addEventListener('click', clickEvent => {
                  const secondLevelLink = link.closest('.navigation-mega__indepth-list-item').querySelector('.collapsible__trigger').querySelector('a').text.trim();
                  const firstLevelLink = link.closest('.navigation-mega__indepth-content').querySelector('.navigation-mega__subtitle').querySelector('span').innerText.trim();
                  const textForDatalayerEvent = `${firstLevelLink}|${secondLevelLink}|${link.text.trim()}`;

                  this.triggerDataLayerEvent(textForDatalayerEvent, 3);
                });
              });
            }

          });
        }

      });
    }

    this.mobileIndepthLink.forEach( element => {
      element.addEventListener('click', (clickEvent) => {
        const listItem = clickEvent.target.closest(`.${this.classes.indepthListItem}`);
        if (!listItem.classList.contains(`${this.classes.indepthListItemActive}`)) {
          listItem.classList.add(`${this.classes.indepthListItemActive}`);
        }

        this.mobileMenuContainer.classList.toggle(`${this.classes.secondLevelActive}`);
      });
    });

    this.mobileBackLink.forEach( element => {
      element.addEventListener('click', (clickEvent) => {
        const listItem = clickEvent.target.closest(`.${this.classes.indepthListItem}`);
        if (listItem.classList.contains(`${this.classes.indepthListItemActive}`)) {
          listItem.classList.remove(`${this.classes.indepthListItemActive}`);
        }

        this.mobileMenuContainer.classList.toggle(`${this.classes.secondLevelActive}`);
      });
    });

    this.mobileClose.forEach( item => {
      item.addEventListener('click', () => {
        this.navClose.click();

        if (this.mobileMenuContainer.classList.contains(`${this.classes.secondLevelActive}`)) {
          this.mobileMenuContainer.classList.remove(this.classes.secondLevelActive);
        }

        if (this.mobileMenuItem.length) {
          this.mobileMenuItem.forEach( item => {
            if (item.classList.contains(`${this.classes.indepthListItemActive}`)) {
              item.classList.remove(this.classes.indepthListItemActive);
            }
          });
        }
      });
    });

    this.menuItems.forEach( menuItem => {
      menuItem.addEventListener('mouseenter', this.openSubmenu);

      const menuLink = menuItem.querySelector('.navigation-mega__menu-link').querySelector('a');
      menuLink.addEventListener('click', clickEvent => {

        const firstLevelLinkText = menuLink.text;
        const textForDatalayerEvent = `${firstLevelLinkText.trim()}`;

        this.triggerDataLayerEvent(textForDatalayerEvent, 1);
      });
    });

    this.mobileFirstLevelMenuItems.forEach( menuItem => {

      const menuLink = menuItem.querySelector('.link-list__link').querySelector('a');
      menuLink.addEventListener('click', clickEvent => {
        const firstLevelLinkText = menuLink.text;
        const textForDatalayerEvent = `${firstLevelLinkText.trim()}`;

        this.triggerDataLayerEvent(textForDatalayerEvent, 1);
      });
    });

    this.element.addEventListener('mouseleave', this.closeSubMenus);
    this.megaMenuCloseBtns.forEach(closeBtn => {
      closeBtn.addEventListener('click', this.closeSubMenus);
    });

    this.openInDepthMenu();
  }

  openSubmenu(event) {
    const element = event.target;
    const subMenu = element.querySelector('[data-navigation-mega-submenu]');

    if (!!this.overlay === true && !!subMenu === true) {
      this.overlay.classList.remove(this.classes.hidden);
    } else {
      this.overlay.classList.add(this.classes.hidden);

      // hide all indepth menus
      this.indepthContents.forEach((indepthContent) => {
        indepthContent.classList.add('is-hidden');
      });

      // remove all active indepth menu items
      this.indepthItems.forEach((inDepthItem) => {
        inDepthItem.classList.remove('is-active');
      });
    }

    this.submenus.forEach(function (submenu) {
      submenu.classList.add('is-hidden');
    });

    this.menuItems.forEach(function (item) {
      item.classList.remove('is-active');
    });

    element.classList.add(this.classes.active);

    if (!!subMenu === true) {
      subMenu.classList.remove(this.classes.hidden);
    }
  }

  closeSubMenus() {
    // hide all submenus
    this.submenus.forEach(function (submenu) {
      submenu.classList.add('is-hidden');
    });

    // remove all active menu items
    this.menuItems.forEach(function (item) {
      item.classList.remove('is-active');
    });

    // hide all indepth menus
    this.indepthContents.forEach((indepthContent) => {
      indepthContent.classList.add('is-hidden');
    });

    // remove all active indepth menu items
    this.indepthItems.forEach((inDepthItem) => {
      inDepthItem.classList.remove('is-active');
    });

    // hide overlay
    if (!!this.overlay === true) {
      this.overlay.classList.add(this.classes.hidden);
    }
  }

  openInDepthMenu() {
    const element = this;
    this.indepthItems.forEach((item) => {
      item.addEventListener('mouseenter', function () {
        const indepthContent = item.querySelector('[data-navigation-mega-indepth-content]');
        element.indepthContents.forEach((indepthContent) => {
          indepthContent.classList.add('is-hidden');
        });

        element.indepthItems.forEach((inDepthItem) => {
          inDepthItem.classList.remove('is-active');
        });

        item.classList.add('is-active');

        if (!!indepthContent === true) {
          indepthContent.classList.remove('is-hidden');
        }
      });
    });
  }

  /**
   * Declare attribute constants.
   */
  get classes() {
    return {
      indepthListItem: 'navigation-mega__indepth-list-item',
      indepthListItemActive: 'navigation-mega__indepth-list-item--active',
      secondLevelActive: 'navigation-mega__second-level',
      active: 'is-active',
      hidden: 'is-hidden'
    };
  }

  /**
   * Get selector.
   */
  static getSelector() {
    return `[${attributeBase}]`;
  }
}
